export enum Actions {
  ActiveApprovalModel = "active-approval-model",
  ActiveCustomerEmployee = "active-customer-employee",
  ActiveExpenseType = "active-expense-type",
  ActiveJustification = "active-justification",
  ActivePolicy = "active-policy",
  ActivePolicyValueExpense = "active-policy-value-expense",
  ActiveReasonTrip = "active-reason-trip",
  CancelAirwayOrder = "cancel-airway-order",
  CreateProfileApprover = "create-profile-approver",
  CreateApprovalModel = "create-update-approval-model",
  CreateCostCenter = "create-cost-center",
  CreateCustomerEmployee = "create-update-customer-employee",
  CreateUpdateCustomerEmployeesGroup = "create-update-customer-employee-group",
  CreateExpenseType = "create-expense-type",
  CreateJustification = "create-justification",
  CreateOrder = "create-order",
  CreateOrderForOthers = "create-order-for-others",
  CreateOrderHotel = "create-order-hotel",
  CreatePolicy = "create-policy",
  UpdatePolicyValue = "update-policy-value",
  CreatePolicyParameter = "create-policy-parameter",
  CreatePolicyValue = "create-update-policy-value",
  CreatePolicyValueExpense = "create-policy-value-expense",
  CreateProfile = "create-profile",
  CreateReasonTrip = "create-reason-trip",
  DeleteCostCenter = "delete-cost-center",
  DeleteExpenseType = "delete-expense-type",
  DoneAirwayOrder = "done-airway-order",
  ViewCustomerEmployee = "view-customer-employee",
  ViewCustomerEmployeesGroup = "view-customer-employee-group",
  GetDetailsExpenseType = "get-details-expense-type",
  GetExpenseType = "view-expense-type",
  GetOrder = "get-order",
  GetPolicyValueExpense = "get-policy-value-expense",
  GetProfile = "get-profile",
  ViewReasonTrip = "view-reason-trip",
  InactiveApprovalModel = "inactive-approval-model",
  InactiveCustomerEmployee = "inactive-customer-employee",
  InactiveExpenseType = "inactive-expense-type",
  InactiveJustification = "inactive-justification",
  InactivePolicy = "inactive-policy",
  InactivePolicyValueExpense = "inactive-policy-value-expense",
  InactiveReasonTrip = "inactive-reason-trip",
  SetActionProfile = "set-action-profile",
  SetDefaultProfile = "set-default-profile",
  UpdateApprovalModel = "update-approval-model",
  UpdateCostCenter = "update-cost-center",
  UpdateCustomerEmployee = "update-customer-employee",
  UpdateExpenseType = "update-expense-type",
  UpdateJustification = "update-justification",
  UpdatePolicy = "update-policy",
  CreateUpdateProject = "create-update-project",
  CreateUpdateBudget = "create-update-budget",
  UpdatePolicyValueExpense = "update-policy-value-expense",
  UpdateProfile = "update-profile",
  UpdateReasonTrip = "update-reason-trip",
  ViewAirwayOrder = "view-airway-order",
  ViewAnyApprovalModel = "view-any-approval-model",
  ViewAnyPolicy = "view-any-policy",
  ViewApprovalModel = "view-approval-model",
  ViewBranch = "view-branch",
  ViewCostCenter = "view-cost-center",
  ViewCustomerProfiles = "view-customer-profiles",
  ViewHotelOrder = "view-hotel-order",
  ViewJustification = "view-justification",
  ViewPolicy = "view-policy",
  ViewPolicyParameter = "view-policy-parameter",
  ViewSettingParameter = "view-setting-parameter",
  UpdateSettingParameter = "update-setting-parameter",
  ViewPolicyValue = "view-policy-value",
  ViewProject = "view-project",
  ViewOrder = "view-order",
  ViewAllOrders = "view-all-order",
  ViewAccountabilityExpense = "view-accountability-expense",
  ViewDashboard = "view-dashboard",
  ViewPurchaseReport = "view-purchase-report",
  CreateUpdateExpenseReport = "create-update-expense-report",
  ViewAirwaySeats = "view-airway-seats",
  ViewCreditLimit = "view-credit-limit",
  CreateVehicleOrder = "create-vehicle-order",
  CreateAirwayOrder = "create-airway-order",
  CreateHotelOrder = "create-hotel-order",
  CreateRoadOrder = "create-road-order",
  ViewBudget = "view-budget",
  ViewBudgetBalance = "view-budget-balance",
  ApprovalAll = "approver-all",
  ViewExpense = "view-expense",
  CreateUpdateExpense = "create-update-expense",
  ViewExpenseReport = "view-expense-report",
  ApproveExpense = "approve-expense",
  RejectExpense = "reject-expense",
  ViewAdvanceOrder = "view-advance-order",
  CreateUpdateAdvanceOrder = "create-update-advance-order",
  RemoveAdvanceOrder = "remove-advance-order",
  ApproveAdvanceOrder = "approve-advance-order",
  RejectAdvanceOrder = "reject-advance-order",
  PayAdvanceOrder = "pay-advance-order",
  PayRefund = "pay-refund",
  ReceiveRefund = "receive-refund",
  CreateUpdateAccountabilityExpense = "create-update-accountability-expense",
  CreateUpdatePolicyValueExpense = "create-update-policy-value-expense",
  ManagerListCards = "manager-view-list-cards",
  ManagerViewBalances = "manager-view-balances",
  ManagerAddBalance = "manager-add-balance",
  ManagerViewMainBalance = "manager-view-main-balance",
  ManagerCreditMainAccount = "main-credit-main-account",
  BlockCard = "block-card",
  ViewFixedDailyLodging = "view-fixed-daily-lodging",
  ViewBankAccount = "view-bank-account",
  CreateUpdateBankAccount = "create-update-bank-account",
  ActiveInactiveBankAccount = "active-inactive-bank-account",
}

export const managerCardActions = [
  Actions.ManagerListCards,
  Actions.ManagerViewBalances,
  Actions.ManagerAddBalance,
  Actions.ManagerViewMainBalance,
  Actions.ManagerCreditMainAccount,
  Actions.BlockCard,
];
